import { makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';

import { MEDIA_CONFIG, MEDIA_DEFAULTS, type MediaConfig } from './media.config';

/**
 * The single entry an app adds to opt into `@sisoma/media` — it sets the
 * {@link MEDIA_CONFIG} override the library's two services read their base URL
 * from:
 *
 * ```ts
 * provideMedia({ apiUrl: environment.apiUrl })
 * ```
 *
 * Unlike `provideAuth()` this registers **no** `HttpClient`: both services
 * inject the one the app already configured, and a second
 * `provideHttpClient(...)` would replace the auth interceptor chain that
 * supplies their credentials.
 *
 * It registers no services either. `MediaLibraryService` is provided by
 * `MediaPicker` at the component level and `CloudinaryUploadService` by
 * whichever component owns an upload, so each dialog gets its own instance and
 * neither outlives the screen that opened it.
 *
 * Returns `EnvironmentProviders` so the config can only be set at the
 * environment level.
 */
export function provideMedia(config: Partial<MediaConfig>): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: MEDIA_CONFIG, useValue: { ...MEDIA_DEFAULTS, ...config } },
  ]);
}
